import styled from 'styled-components/macro';
import { ThemedComponent } from '@la/ds-ui-components';

export const AutopayPaymentMethodWarning = styled.div<ThemedComponent>(
  ({ theme }: ThemedComponent) => ({
    padding: '0 24px 8px',

    '& > div': {
      backgroundColor: theme.foundational.orange[50],
      alignItems: 'flex-start',
      height: 'auto',

      svg: {
        stroke: theme.foundational.orange[700],
        width: '24px',
        height: '24px',
      },
    },
  })
);

export const AutopayContainer = styled.div<ThemedComponent>(
  ({ theme }: ThemedComponent) => ({
    marginTop: '16px',
    padding: '0',

    label: {
      color: theme.foundational.blueGrey[900],
      '&[data-disabled]': {
        color: theme.foundational.blueGrey[200],
      },
    },
  })
);

export const AutopayDisclaimer = styled.div<ThemedComponent>(
  ({ theme }: ThemedComponent) => ({
    color: theme.foundational.blueGrey[600],
    marginTop: '8px',
  })
);
